import React from 'react'
import PropTypes from 'prop-types'

const PersonSearchIcon = (props) => {
  const { color = '#A8A8A8', classes = 'w-20' } = props
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <path
        d="M7.5 8.25C9.1575 8.25 10.5 6.9075 10.5 5.25C10.5 3.5925 9.1575 2.25 7.5 2.25C5.8425 2.25 4.5 3.5925 4.5 5.25C4.5 6.9075 5.8425 8.25 7.5 8.25ZM7.5 3.75C8.325 3.75 9 4.425 9 5.25C9 6.075 8.325 6.75 7.5 6.75C6.675 6.75 6 6.075 6 5.25C6 4.425 6.675 3.75 7.5 3.75Z"
        fill={color}
      />
      <path
        d="M3 12.75C3.165 12.21 5.4825 11.25 7.5 11.25C7.5 10.725 7.5975 10.2225 7.7625 9.7575C5.715 9.6825 1.5 10.7025 1.5 12.75V14.25H8.655C8.265 13.815 7.9575 13.3125 7.7625 12.75H3Z"
        fill={color}
      />
      <path
        d="M14.5725 12.765C14.8425 12.3225 15 11.805 15 11.25C15 9.5925 13.6575 8.25 12 8.25C10.3425 8.25 9 9.5925 9 11.25C9 12.9075 10.3425 14.25 12 14.25C12.555 14.25 13.0725 14.085 13.515 13.8225C14.2125 14.52 14.73 15.0375 15.4425 15.75L16.5 14.6925C15.375 13.5675 15.9075 14.0925 14.5725 12.765ZM12 12.75C11.175 12.75 10.5 12.075 10.5 11.25C10.5 10.425 11.175 9.75 12 9.75C12.825 9.75 13.5 10.425 13.5 11.25C13.5 12.075 12.825 12.75 12 12.75Z"
        fill={color}
      />
    </svg>
  )
}

PersonSearchIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(PersonSearchIcon)
